import React, { Component } from 'react'
import { Field } from 'redux-form/immutable'
import { Redirect } from 'react-router-dom'
import cn from 'classnames'

import Input from 'app/components/Input'
import Button from 'app/components/ButtonDefault'
import { required, email } from 'helpers/validators'
import InputPhoneNumber from 'app/domains/common/InputPhoneNumber'
import LoginInformationModal from 'app/domains/common/Modals/LoginInformationModal'
import CheckEmailSpamIcon from 'app/components/SVGS/CheckEmailSpamIcon'
import { exclusionSpecialSymbolsForUserName } from 'helpers/exclusionSpecialSymbols'

import './styles.scss'
export const bc = 'start-invite'
class Start extends Component {
  hideFreshWidgetCustomImage = () => {
    // freshWidgetCollection is HTMLCollection, must be one on the page
    const freshWidgetCollection = document.getElementsByClassName('freshwidget-customimage')
    if (freshWidgetCollection && freshWidgetCollection.length) {
      freshWidgetCollection.item(0).style.display = 'none'
    }
  }

  componentDidUpdate() {
    const { showModal } = this.props
    const { isShowLoginInformationModal } = this.props
    this.hideFreshWidgetCustomImage()
    if (isShowLoginInformationModal) {
      showModal(
        <LoginInformationModal
          title="Don't see your invite email? "
          text="Check Spam – it might have gone there, right next to that message from your long lost uncle with all that inheritance money."
          icon={<CheckEmailSpamIcon />}
          clearAuthStatuses={() => {}}
          withoutCross
        />,
        {
          size: 'xs',
          onRequestClose: () => {},
        }
      )
    }
  }

  componentDidMount() {
    this.props.closeShowLoginInformationModal()
  }

  render() {
    const {
      formTitle,
      formSubTitle,
      handleSubmit,
      form,
      invalid,
      isPromoPageActive,
      t,
      isPhoneRequired,
      onBlurCustom,
      customClassName,
      isPageEdit,
    } = this.props
    if (!isPromoPageActive) {
      return <Redirect from="/start" to="/login" />
    }
    return (
      <div className={cn(`${bc}__wrapper`, { [customClassName]: customClassName })}>
        <div className={`${bc}__content`}>
          <div className={`${bc}__body`}>
            {!isPageEdit && (
              <>
                <span className={`${bc}__title`}>{formTitle}</span>
                <p className={`${bc}__subtitle`}>{formSubTitle}</p>
              </>
            )}
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <Field
                name="firstName"
                component={Input}
                label={t('First Name')}
                labelClass={`${bc}__label`}
                placeholder={t('Enter first name')}
                normalize={exclusionSpecialSymbolsForUserName}
                className={`${bc}__input-wrapper`}
                validate={[required()]}
                onBlur={onBlurCustom}
              />
              <Field
                name="lastName"
                component={Input}
                label={t('Last Name')}
                labelClass={`${bc}__label`}
                placeholder={t('Enter last name')}
                normalize={exclusionSpecialSymbolsForUserName}
                className={`${bc}__input-wrapper`}
                validate={[required()]}
                onBlur={onBlurCustom}
              />
              <Field
                name="email"
                component={Input}
                label={t('Email')}
                labelClass={`${bc}__label`}
                placeholder={t('Enter email')}
                className={`${bc}__input-wrapper`}
                validate={[required(), email]}
                onBlur={onBlurCustom}
              />
              <InputPhoneNumber
                label={t(`Mobile Number ${!isPhoneRequired ? '(Optional)' : ''}`)}
                errorLabel={'Your phone number is a'}
                labelClass={`${bc}__label`}
                className={`${bc}__input-wrapper`}
                inputClass={`${bc}__input`}
                form={form}
                classNamePhoneComponentWrapper={`${bc}__select-phone-code`}
                classNamePhoneComponentItem={`${bc}__select-phone-code`}
                isRequired={isPhoneRequired}
                onBlur={onBlurCustom}
              />
              <Button className={`${bc}__button`} type="submit" stretched disabled={invalid || isPageEdit}>
                {t('sign up')}
              </Button>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export default Start
